import { cn } from '@lib/utils';
import loadingGif from '../../../assets/loading.gif';

interface FullScreenLoadingProps {
  title?: string;
  subtitle?: string;
  className?: string;
  variant?: 'default' | 'gradient';
}

export function FullScreenLoading({ 
  title = 'Loading YepAI', 
  subtitle = 'Preparing your experience...',
  className,
  variant = 'default'
}: FullScreenLoadingProps) {
  return (
    <div className={cn(
      'min-h-screen flex items-center justify-center relative overflow-hidden',
      variant === 'gradient' 
        ? 'bg-gradient-to-br from-purple-50 via-white to-blue-50' 
        : 'bg-white',
      className
    )}>
      {/* Background circle on the right */}
      <div className="absolute -right-[20vh] top-1/2 -translate-y-1/2 w-[80vh] h-[80vh] rounded-full bg-purple-100/30 blur-[100px]" />
      
      <div className="flex flex-col items-center space-y-10 relative z-10">
        {/* Loading GIF */}
        <div className="w-36 h-36">
          <img 
            src={loadingGif} 
            alt="Loading"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Loading text */}
        <div className="text-center space-y-4">
          <h2 className="text-3xl font-medium text-gray-900 tracking-tight">{title}</h2>
          {subtitle && (
            <p className="text-base text-gray-500">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
}